import React from 'react';
import IconMask from './assets/face-mask.png';
import SectionBox from './SectionBox';

function CovidSection() {
  return (
    <div id="fh5co-couple">
      <div className="container">
        <div className="row">
          <div className="col-md-8 col-md-offset-2 text-center fh5co-heading">
            <h2 className="main-font">Información adicional</h2>
            <p className="info" style={{ marginBottom: '-16px' }}>
            Vestimenta formal.  
            Apreciamos mucho a sus hijos, pero en esta ocasión deseamos que disfruten de una mañana especial dedicada exclusivamente a ustedes. Este evento será solo para adultos. Agradecemos su comprensión.
            </p>
          </div>
        </div>
        {/* BOX INFO */}
      </div>
    </div>
  );
}

export default CovidSection;
